export default "__VITE_ASSET__ae7b5178__"